export default __webpack_public_path__ + "static/media/naveen.de20563f.png";